import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.valueMeterForms

export const getHouseHoldValueMeterForm = createSelector(
  _getState,
  (state) => state.houseHoldValueMeterForm
)

export const getRebuildValueMeterForm = createSelector(
  _getState,
  (state) => state.rebuildValueMeterForm
)
